// Generated by robots, do not change this manually!

/** Базовый белый цвет совпадает с whitePrimary */
export const white = 'var(--plasma-colors-white, #FFFFFF)';

/** Первичный белый цвет */
export const whitePrimary = 'var(--plasma-colors-white-primary, #FFFFFF)';

/** Вторичный белый цвет */
export const whiteSecondary = 'var(--plasma-colors-white-secondary, rgba(255, 255, 255, 0.56))';

/** Третичный белый цвет */
export const whiteTertiary = 'var(--plasma-colors-white-tertiary, rgba(255, 255, 255, 0.28))';

/** Базовый черный цвет совпадает с blackPrimary */
export const black = 'var(--plasma-colors-black, #080808)';

/** Первичный черный цвет */
export const blackPrimary = 'var(--plasma-colors-black-primary, #080808)';

/** Вторичный черныйцвет */
export const blackSecondary = 'var(--plasma-colors-black-secondary, rgba(8, 8, 8, 0.56))';

/** Третичный черный цвет */
export const blackTertiary = 'var(--plasma-colors-black-tertiary, rgba(8, 8, 8, 0.28))';

/** Прозрачный цвет */
export const transparent = 'var(--plasma-colors-transparent, rgba(0, 0, 0, 0))';

/** Базовый цвет текста, совпадает с primary */
export const text = 'var(--plasma-colors-text, rgba(255, 255, 255, 0.96))';

/** Первичный цвет текста */
export const primary = 'var(--plasma-colors-primary, rgba(255, 255, 255, 0.96))';

/** Вторичный цвет текста */
export const secondary = 'var(--plasma-colors-secondary, rgba(255, 255, 255, 0.56))';

/** Третичный цвет текста */
export const tertiary = 'var(--plasma-colors-tertiary, rgba(255, 255, 255, 0.28))';

/** Базовый цвет фона, совпадает с backgroundPrimary */
export const background = 'var(--plasma-colors-background, #080808)';

/** Первичный цвет фона */
export const backgroundPrimary = 'var(--plasma-colors-background-primary, #1A1A1A)';

/** Вторичный цвет фона */
export const backgroundSecondary = 'var(--plasma-colors-background-secondary, #333333)';

/** Третичный цвет текста */
export const backgroundTertiary = 'var(--plasma-colors-background-tertiary, #525252)';

/** Цвет предупреждения */
export const warning = 'var(--plasma-colors-warning, #EF6B25)';

/** Цвет ошибки */
export const critical = 'var(--plasma-colors-critical, #DC283A)';

/** Цвет фона паранжи */
export const overlay = 'var(--plasma-colors-overlay, rgba(0, 0, 0, 0.8))';

/** Цвет подложки 1 */
export const surfaceLiquid01 = 'var(--plasma-colors-surface-liquid01, rgba(255, 255, 255, 0.06))';

/** Цвет подложки 2 */
export const surfaceLiquid02 = 'var(--plasma-colors-surface-liquid02, rgba(255, 255, 255, 0.12))';

/** Цвет подложки 3 */
export const surfaceLiquid03 = 'var(--plasma-colors-surface-liquid03, rgba(255, 255, 255, 0.12))';

/** Цвет подложки карточек */
export const surfaceCard = 'var(--plasma-colors-surface-card, rgba(255, 255, 255, 0.12))';

/** Первичный цвет контролов */
export const buttonPrimary = 'var(--plasma-colors-button-primary, #FFFFFF)';

/** Вторичный цвет контролов */
export const buttonSecondary = 'var(--plasma-colors-button-secondary, rgba(255, 255, 255, 0.12))';

/** Цвет предупреждения у контролов */
export const buttonWarning = 'var(--plasma-colors-button-warning, #EF6B25)';

/** Цвет ошибки у контролов */
export const buttonCritical = 'var(--plasma-colors-button-critical, #DC283A)';

/** Цвет зажатого контрола */
export const buttonChecked = 'var(--plasma-colors-button-checked, #FFFFFF)';

/** Цвет фона баблов отправленный сообщений */
export const speechBubbleSent = 'var(--plasma-colors-speech-bubble-sent, rgba(0, 0, 0, 0.28))';

/** Цвет фона баблов получнных сообщений */
export const speechBubbleReceived = 'var(--plasma-colors-speech-bubble-received, rgba(255, 255, 255, 0.12))';

/** Акцентный цвет призыва к действию */
export const accent = 'var(--plasma-colors-accent, #2AC673)';

/** Акцентный цвет у контролов */
export const buttonAccent = 'var(--plasma-colors-button-accent, #12A557)';

/** Цвет рамки фокуса у контрола */
export const buttonFocused = 'var(--plasma-colors-button-focused, #2AC673)';

/** Градиент для заливки основного фона */
export const gradient = 'var(--plasma-colors-gradient, linear-gradient(336.84deg, rgba(20, 116, 70, 0.6) 0%, rgba(8, 8, 8, 0) 64.88%), radial-gradient(100% 100% at 75.89% 100%, rgba(0, 133, 255, 0.24) 0%, rgba(0, 71, 255, 0.03) 100%), linear-gradient(180deg, rgba(8, 8, 8, 0) 50%, rgba(7, 71, 33, 0.3) 100%), linear-gradient(270deg, #061621 0%, rgba(8, 8, 8, 0) 100%))';

/** Градиент подсказок о голосовых запросах */
export const voicePhraseGradient = 'var(--plasma-colors-voice-phrase-gradient, linear-gradient(93.97deg, #2FD65C 6.49%, #20C1C7 93.51%))';

